import React from "react";
import { GenericSignal, SignalType } from "@types";
import css from "../UsersChangedSignalContent.module.scss";

export const getTitle = (
  signal: GenericSignal<
    | SignalType.ToAdded
    | SignalType.ToRemoved
    | SignalType.CcAdded
    | SignalType.CcRemoved
    | SignalType.ToThirdPartyAdded
    | SignalType.ToThirdPartyRemoved
    | SignalType.CcThirdPartyAdded
    | SignalType.CcThirdPartyRemoved
  >
): string | React.ReactNode => {
  const attrs = {
    subtitle: {
      className: css.subtitle,
    },
  };

  if ("removed" in signal.eventMetadata) {
    const participantsLength = signal.eventMetadata?.removed?.length || 0;
    const participant = signal.eventMetadata?.removed?.[0];
    const [participantFirstName, participantLastName] = participant?.name?.split(" ") || [];
    const participantName = participantLastName
      ? `${participantFirstName} ${participantLastName[0]}.`
      : participant?.email || "User";

    if (signal.eventName === SignalType.CcRemoved) {
      return participantsLength > 1
        ? `${participantsLength} people were removed from CC`
        : "Someone was removed from CC";
    }

    if (signal.eventName === SignalType.ToThirdPartyRemoved) {
      return participantsLength > 1 ? (
        `${participantsLength} participants removed`
      ) : (
        <>
          {participantName}
          <br />
          <span {...attrs.subtitle}>was removed from the conversation</span>
        </>
      );
    }

    if (signal.eventName === SignalType.CcThirdPartyRemoved) {
      return participantsLength > 1 ? (
        `${participantsLength} people were removed from CC`
      ) : (
        <>
          The CCed 3rd party may have been
          <br />
          removed from the conversation
        </>
      );
    }

    return participantsLength > 1 ? (
      `${participantsLength} participants removed`
    ) : (
      <>
        {participantName}
        <br />
        <span {...attrs.subtitle}>was removed from the conversation</span>
      </>
    );
  }

  const participantsLength = signal.eventMetadata?.added?.length || 0;
  const participant = signal.eventMetadata?.added?.[0];
  const [participantFirstName, participantLastName] = participant?.name?.split(" ") || [];
  const participantName = participantLastName
    ? `${participantFirstName} ${participantLastName[0]}.`
    : participant?.email || "User";

  if (signal.eventName === SignalType.CcAdded) {
    return participantsLength > 1
      ? `${participantsLength} new people have been CC'ed`
      : "Someone new has been Cc'ed";
  }

  if (signal.eventName === SignalType.ToThirdPartyAdded) {
    return participantsLength > 1 ? (
      `${participantsLength} new participants added`
    ) : (
      <>
        {participantName}
        <br />
        <span {...attrs.subtitle}>was added to the conversation</span>
      </>
    );
  }

  if (signal.eventName === SignalType.CcThirdPartyAdded) {
    return participantsLength > 1 ? (
      `${participantsLength} new people have been CC’ed`
    ) : (
      <>
        The CCed 3rd party have been added
        <br />
        to the conversation
      </>
    );
  }

  return participantsLength > 1 ? (
    `${participantsLength} new participants added`
  ) : (
    <>
      {participantName}
      <br />
      <span {...attrs.subtitle}>was added to the conversation</span>
    </>
  );
};
